import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    MenuItemContainer as SourceMenuItemContainer
} from 'SourceComponent/MenuItem/MenuItem.container';
import { noopFn } from 'Util/Common';

/** @namespace PeggysagePwa/Component/MenuItem/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
});

/** @namespace PeggysagePwa/Component/MenuItem/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
});

/** @namespace PeggysagePwa/Component/MenuItem/Container */
export class MenuItemContainer extends SourceMenuItemContainer {
    static propTypes = {
        ...SourceMenuItemContainer.propTypes,
        isButton: PropTypes.bool,
        onClick: PropTypes.func
    };

    static defaultProps = {
        ...SourceMenuItemContainer.defaultProps,
        isButton: false,
        onClick: noopFn
    };

    /**
     * Override: if item is a button, call the callback function
     */
    onItemClick(e) {
        const { isButton, onClick } = this.props;

        if (isButton) {
            onClick(e);
            return;
        }

        super.onItemClick();
    }

    /**
     * Override
     */
    containerProps() {
        const { isButton } = this.props;

        return {
            ...super.containerProps(),
            isButton
        };
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuItemContainer);
